(function (window, document) {
  'use strict';

  try {
    if (!window || !document || window.__jlContactPrivyr) { return; }
    window.__jlContactPrivyr = true;

    function attr(element, name) {
      return element && element.getAttribute ? (element.getAttribute(name) || '') : (element && element[name] ? element[name] : '');
    }

    function fields(form) {
      return form && form.elements ? form.elements : (form && form.querySelectorAll ? form.querySelectorAll('input, textarea') : []);
    }

    function isContactForm(form) {
      var items = fields(form);
      var i;
      for (i = 0; i < items.length; i += 1) {
        if ((items[i].type || '').toLowerCase() === 'hidden' && attr(items[i], 'name') === 'form_type' && items[i].value === 'contact') {
          return true;
        }
      }
      return false;
    }

    function findField(form, kind) {
      var items = fields(form);
      var i;
      var item;
      var name;
      for (i = 0; i < items.length; i += 1) {
        item = items[i];
        name = attr(item, 'name');
        if (kind === 'phone' && ((item.type || '').toLowerCase() === 'tel' || /phone|mobile/i.test(name))) { return item; }
        if (kind === 'name' && /\[.*name.*\]/i.test(name) && !/email/i.test(name)) { return item; }
        if (kind === 'message' && /^contact\[[^\]]*(comment|message|body)[^\]]*\]$/i.test(name)) { return item; }
        if (kind === 'product' && name === 'contact[Product URL]') { return item; }
      }
      return null;
    }

    function redactEmails(value) {
      return String(value || '').replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '');
    }

    function cleanProductUrl(value, currentLocation) {
      try {
        var parsed = new window.URL(String(value || ''), currentLocation.origin);
        return parsed.origin === currentLocation.origin ? currentLocation.origin + parsed.pathname : '';
      } catch (ignore) {
        return '';
      }
    }

    document.addEventListener('submit', function (event) {
      try {
        var form = event && event.target;
        var phone;
        var digits;
        var name;
        var message;
        var product;
        var productUrl;
        var campaign;
        var currentLocation;
        var payload;
        var json;
        var url = 'https://aria.jainsonslights.com/lead';
        var request;

        if (!isContactForm(form)) { return; }
        phone = findField(form, 'phone');
        digits = phone && phone.value ? String(phone.value).replace(/\D/g, '') : '';
        if (digits.length < 10) { return; }

        name = findField(form, 'name');
        message = findField(form, 'message');
        product = findField(form, 'product');
        campaign = product ? 'product-question' : 'contact-page';
        currentLocation = window.location;
        productUrl = product && product.value ? cleanProductUrl(product.value, currentLocation) : '';
        payload = {
          name: name && name.value ? redactEmails(name.value) : '',
          mobile: digits.slice(-10),
          message: message && message.value ? redactEmails(message.value).slice(0, 500) : '',
          project_type: product ? 'Product question' : 'Contact form',
          source_campaign: campaign,
          source_url: currentLocation.origin + currentLocation.pathname,
          form: campaign
        };
        if (productUrl) { payload.product_url = productUrl; }
        json = JSON.stringify(payload);

        if (typeof window.fetch === 'function') {
          request = window.fetch(url, {
            method: 'POST',
            mode: 'cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: json
          });
          if (request && typeof request.catch === 'function') { request.catch(function () {}); }
        } else if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
          window.navigator.sendBeacon(url, new Blob([json], { type: 'text/plain' }));
        }
      } catch (ignore) {}
    }, true);
  } catch (ignore) {}
}(window, document));
